import React, { Suspense, useState } from "react";
import { Link } from "react-router-dom";
// import { useAuth0 } from "@auth0/auth0-react";
import { useSelector } from "react-redux";
import { CircularProgress, ClickAwayListener, Skeleton } from "@mui/material";
import { lazily } from "react-lazily";
import { TaleLoadingFallback } from "@components/TaleLoadingFallback";
import { isAdmin, isCompanyUser } from "@/utils/roleStorage";
import { Person } from "@mui/icons-material";
const { UserMenu } = lazily(() => import("./UserMenu"));
const { NotificationBar } = lazily(() =>
    import("./NotificationBar")
);

// Header component
const Header = ({ role, toggleSidebar }) => {
    const [showNotifications, setShowNotifications] = useState(false);
    const [showUserMenu, setShowUserMenu] = useState(false);

    const { user: currentUser } = useSelector((s) => s.auth);

    const isCompanyAccount = currentUser?.userType === "COMPANY_USER" || currentUser?.userType === "COMPANY_ADMIN";
    const avatarUrl = isCompanyAccount ? currentUser?.companyLogoUrl : currentUser?.profilePictureUrl;

    // Function to handle notification bar visibility
    const handleNotificationClick = () => {
        setShowNotifications(!showNotifications);
        setShowUserMenu(false);
    };

    // Function to handle user menu visibility
    const handleUserButtonClick = () => {
        setShowUserMenu(!showUserMenu);
        setShowNotifications(false);
    };

    return (
        <div className="flex justify-between items-center gap-4">
            <div className="flex items-center gap-4">
                <Link className="flex items-center justify-center" to={`/`}>
                    {!role ? (
                        <Skeleton
                            animation="wave"
                            style={{
                                width: 160,
                                minHeight: 80,
                            }}
                        />
                    ) : (
                        <img
                            src={`/assets/logo/${
                                isCompanyUser() ? "business" : "tale"
                            }.png`}
                            alt="LogoTale"
                            style={{
                                width: 160,
                                height: 48,
                                objectFit: "contain",
                            }}
                        />
                    )}
                </Link>
                <div
                    style={{
                        background: "rgba(255, 255, 255, 0.70)",
                        borderRadius: 9999,
                        width: 40,
                        height: 40,
                        cursor: "pointer",
                    }}
                    className="flex justify-center items-center"
                    onClick={toggleSidebar}
                >
                    {!role ? (
                        <CircularProgress className="!size-2/5" />
                    ) : (
                        <img
                            className="size-4/5"
                            src={`/assets/${isAdmin() ? "normal" : role}/burger.png`}
                            alt="Burger Menu"
                        />
                    )}
                </div>
            </div>
            {/* Header buttons container */}
            <div className="flex items-center gap-6">
                {/* Messaging button */}
                <div
                    style={{
                        justifyContent: "center",
                        alignItems: "center",
                        display: "flex",
                    }}
                >
                    <img
                        src={`/assets/${isAdmin() ? "normal" : role}/mail.png`}
                        alt="LogoTale"
                        style={{ width: "24px", height: "24px" }}
                        className="object-contain"
                    />
                </div>

                {/* Notification button */}
                <div
                    className="relative"
                    style={{ cursor: "pointer" }}
                    onClick={handleNotificationClick}
                >
                    <img
                        src={`/assets/${
                            isAdmin() ? "normal" : role
                        }/notification.png`}
                        alt="notif"
                        style={{ width: "24px", height: "24px" }}
                        className="object-contain"
                    />
                    {/* Notification Bar */}
                    {showNotifications && (
                        <ClickAwayListener onClickAway={() => setShowNotifications(false)}>
                            <div
                                className={`absolute !top-[calc(100%+10px)] right-0 rtl:right-auto rtl:left-0 shadow-lg z-10 !min-w-[325px] p-4 bg-white rounded-lg`}
                            >
                                <Suspense fallback={null}>
                                    <NotificationBar />
                                </Suspense>
                            </div>
                        </ClickAwayListener>
                    )}
                </div>

                {/* User menu button */}
                <div
                    className="relative"
                    style={{ cursor: "pointer" }}
                    onClick={handleUserButtonClick}
                >
                    {avatarUrl ? (
                        <img
                            src={avatarUrl}
                            alt="user"
                            style={{
                                width: "48px",
                                height: "48px",
                                borderRadius: "50%",
                                boxShadow: '0px 4px 16px 2px #00000080'
                            }}
                        />
                    ) : (
                        <div
                            style={{
                                width: "48px",
                                height: "48px",
                                borderRadius: "50%",
                                backgroundColor: "#ddd",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                boxShadow: '0px 4px 16px 2px #00000080'
                            }}
                        >
                            <Person style={{ fontSize: 28, color: "#888" }} />
                        </div>
                    )}

                    {/* User menu */}
                    {showUserMenu && (
                        <ClickAwayListener onClickAway={() => setShowUserMenu(false)}>
                            <div
                                className={`absolute !top-[calc(100%+10px)] right-0 rtl:right-auto rtl:left-0 shadow-lg z-10 rounded-lg !min-w-[295px]`}
                            >
                                <Suspense fallback={<TaleLoadingFallback className="py-20" />}>
                                    <UserMenu />
                                </Suspense>
                            </div>
                        </ClickAwayListener>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Header;